import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import {Close} from '@mui/icons-material'
import * as Toast from '@radix-ui/react-toast'

import SnackbarMessageAction from './SnackbarMessageAction'









const SnackbarMessage = (props) => {
  const {action, secondaryAction, message, dismissSnack, showDismissButton} = props
  return (
    _jsx('div', { className: "pb-2 print:hidden" , children: 
      _jsxs('div', {
        className: "pointer-events-auto z-snackbar flex select-none items-center rounded-sm bg-slate-700 p-2 shadow-snackbar"        ,
        onClick: dismissSnack,
 children: [
        _jsx(Toast.Description, { asChild: true, children: 
          _jsx('div', { className: "px-2 py-1.5 text-sm text-white leading-[normal]"    , children: message})
        })
        , _jsx(SnackbarMessageAction, { action: action,} )
        , _jsx(SnackbarMessageAction, { action: secondaryAction,} )
        , showDismissButton && (
          _jsx('button', {
            className: "ml-2 flex cursor-pointer items-center justify-center border-none bg-inherit p-[5px]"       ,
            onClick: (e) => {
              e.stopPropagation()
              dismissSnack()
            },
 children: 
            _jsx(Close, { className: "h-[18px] w-[18px] text-slate-500 hover:opacity-50"   ,} )
          })
        )
      ]})
    })
  )
}

export default SnackbarMessage
